<template>
  <v-main>
    <v-container>
      <div class="home">
        <SelectRoom v-if="currentUser.is_admin" />
        <v-dialog v-model="createDialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
          <div class="text-right mb-2" v-if="currentUser.is_faculty">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">Create New Test</v-btn>
          </div>
          </template>
          <AddTest @closeAddTestDialog="createDialog=false" @refreshList="getAllTests" class="add-test" v-if="currentUser.is_faculty" />

        </v-dialog>

        <v-row no-gutters>
          <v-col>
            <h1 class="space-bottom">Tests</h1>
          </v-col>
          <v-col align="right">
            <v-btn v-if="!previousTests.length" @click="getPreviousTests(true)">Show Previous Tests</v-btn>

            <v-btn v-else @click="previousTests = []">Hide Previous Tests</v-btn>
          </v-col>
        </v-row>
        <h2 v-if="!allTests.length && !previousTests.length">No Tests Found</h2>
        <h2 class="space-bottom" v-if="ongoingTests.length">Ongoing</h2>
        <TestList
          v-if="ongoingTests.length"
          v-bind:all-tests="ongoingTests"
          @deleteTest="deleteTest"
        />

        <h2 class="space-bottom" v-if="upcomingTests.length">Upcoming</h2>
        <TestList
          v-if="upcomingTests.length"
          v-bind:all-tests="upcomingTests"
          @refreshList="getAllTests"
          @deleteTest="deleteTest"
        />
        <div ref="previousTests">
          <h2 class="space-bottom" v-if="previousTests.length">Previous</h2>
          <TestList v-if="previousTests.length" v-bind:all-tests="previousTests" />
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TestList from "../components/tests/TestList";
import testsApi from "@api/tests/all_tests";
import Helper from "@utils/misc";
import moment from "moment";
import SelectRoom from "@components/widgets/SelectRoom";
import api from "@api/index";
import endpoints from "@api/repository";
import AddTest from "@components/tests/AddTest";

export default {
  name: "Home",
  data() {
    return {
      createDialog: false,
      errors: {
        snackbar: false,
        snackbarMessage: "",
      },
      allTests: [],
      previousTests: [],
      paginator: {
        nextUrl: null,
        totalCount: 0,
      },
    };
  },
  components: {
    TestList,
    SelectRoom,
    AddTest,
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser", "adminRoom", "isLoading"]),
    apiEssentials() {
      //consists of essential values standard for all API requests
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiError,
      };
    },
    upcomingTests() {
      return this.allTests.filter((t) =>
        moment(new Date(t.start_datetime * 1000)).isAfter(moment(new Date()))
      );
    },
    ongoingTests() {
      return this.allTests.filter(
        (t) =>
          moment(new Date(t.start_datetime * 1000)).isBefore(
            moment(new Date())
          ) &&
          moment(new Date(t.end_datetime * 1000)).isAfter(moment(new Date()))
      );
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getAllTests() {
      this.$store.dispatch("setLoading", true);
      // get tests from server
      let allTestsFromServer = await testsApi.getAllTests(
        this.accessToken,
        this.adminRoom?.room?.id ?? this.currentUser?.room?.id
      );
      // handle token errors
      if (!Helper.handleErrors(allTestsFromServer, this.handleApiError)) return;

      // display
      this.allTests = allTestsFromServer;
      this.$store.dispatch("setLoading", false);
    },
    // show confirmation box for delete, and if agreed send delete request
    async deleteConfirmation(test) {
      console.log(test);
      this.deleteDialogVisible = true;
    },
    // delete test if confirmation = true, else dont
    async deleteTest(test) {
      this.deleteDialogVisible = false;
      this.setLoading(true);
      let deleteResponse = await testsApi.deleteTest(this.accessToken, test.id); // send delete request to server
      if (!Helper.handleErrors(deleteResponse, this.handleApiError)) return; // check if errors
      this.allTests = this.allTests.filter((t) => t.id != test.id); // if success remove from list
      this.setLoading(false);
    },
    async getPreviousTests(loadNew = false) {
      var roomId = this.adminRoom?.room?.id ?? this.currentUser?.room?.id;

      if (!loadNew && !this.paginator.nextUrl) return; // stop execution if loadNew = false and nexturl also doesnt exist

      var paginatedResponse;
      // decide url: if loadNew = false: on first load, should load by passing roomId else new load: load by passing the nextUrl param
      var url = loadNew
        ? roomId
          ? endpoints.getAllPreviousTests + roomId + "/"
          : endpoints.getAllPreviousFacultyTests
        : this.paginator.nextUrl;

      paginatedResponse = await api.handleApi({
        apiEssentials: this.apiEssentials,
        // if next url exists, then use that or else check if faculty/student/admin by checking roomId
        url: url,
        responseVar: paginatedResponse,
      }); // get paginated response from server
      if (!paginatedResponse) return;

      // save nextUrl and count
      this.paginator.nextUrl = paginatedResponse.next;
      this.paginator.totalCount = paginatedResponse.count;

      // add response to list
      this.previousTests.push(...paginatedResponse.results);
      if (loadNew)
        this.animate(
          document.scrollingElement || document.documentElement,
          "scrollTop",
          "",
          0,
          this.$refs.previousTests.offsetTop,
          200,
          true
        );
    },
    handleScroll() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - 100 && !this.isLoading;
      

      console.log(document.documentElement.offsetHeight - 100);
      console.log(document.documentElement.scrollTop + window.innerHeight);
      if (bottomOfWindow) {
        this.getPreviousTests(false);
      }
    },

    animate(elem, style, unit, from, to, time, prop) {
      if (!elem) {
        return;
      }
      var start = new Date().getTime(),
        timer = setInterval(function () {
          var step = Math.min(1, (new Date().getTime() - start) / time);
          if (prop) {
            elem[style] = from + step * (to - from) + unit;
          } else {
            elem.style[style] = from + step * (to - from) + unit;
          }
          if (step === 1) {
            clearInterval(timer);
          }
        }, 25);
      if (prop) {
        elem[style] = from + unit;
      } else {
        elem.style[style] = from + unit;
      }
    },

    handleApiError(err) {
      console.log(err);
      this.$store.dispatch("setLoading", false);
      // switch(err){
      //   default: {
      //     this.snackbarMessage = "Could not connect to server. Try again!";
      //     this.snackbar = true;
      //     }
      // }
      // if(err.response.code == 4)
    },
  },
  watch: {
    adminRoom() {
      this.getAllTests();
    },
  },
  async created() {
    this.getAllTests();
    console.log("hello");
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.space-bottom {
  margin-bottom: 10px;
}
.text-right {
  text-align: end;
}
</style>